module.exports = __webpack_public_path__ + "media/images/article/polygon_01-da8728cb75eaf617d68cd8a083974d3f.png";